import { getPersistValue } from '../../common/state/persist/Persist.selectors';

const emptyObject = {};
const emptyString = '';

export const getConfigListFilters = state =>
    getPersistValue(state, `configList.filters`, emptyObject);

export const getConfigListSort = state => getPersistValue(state, `configList.sort`, emptyString);

export const getConfigListSortDirection = state =>
    getPersistValue(state, `configList.sortDirection`, 'asc');

export const getConfigListSorting = state => ({
    sort: getConfigListSort(state),
    sortDirection: getConfigListSortDirection(state),
});
